import Loan from './Loan';

const loan = {
    loanModel: Loan
};

export default loan;